<app-upgrade-dosage-upsell
  *ngIf="upgradeDosageOptions.length > 0"
  [form]="form"
  qaIdPrefix="STD Prevention Dosage Upgrade"
>
  <p description class="my-4">
    <ng-container *ngIf="currentDosageData.dosage === '1 Treatment'">
      <strong>You've ordered 1 DoxyPEP treatment.</strong> DoxyPEP works best when taken quickly after sex. With only 1
      treatment, you may not be prepared for future exposures. Upgrade your order today and choose a 15-treatment or
      30-treatment package so you always have some on hand when you need it most.
    </ng-container>
    <ng-container *ngIf="currentDosageData.dosage === '15 Treatments'">
      <strong>You've chosen 15 treatments</strong> - great for staying prepared. But upgrading to 30 treatments gives
      you a longer supply at once, so you never run out and can always act quickly after exposure. It's the most
      cost-effective way to stay protected.
    </ng-container>
    <ng-container *ngIf="currentDosageData.dosage !== '1 Treatment' && currentDosageData.dosage !== '15 Treatments'">
      You're currently receiving {{ currentDosageData.dosage }}. Consider upgrading for extended protection.
    </ng-container>
  </p>

  <div options [formGroup]="form">
    <label class="label">
      <ng-container *ngIf="currentDosageData.dosage === '1 Treatment'"> Select your preferred dosage: </ng-container>
      <ng-container *ngIf="currentDosageData.dosage !== '1 Treatment'">
        Would you like to upgrade your dosage?
      </ng-container>
    </label>

    <!-- Upgrade options -->
    <div class="control" *ngFor="let option of upgradeDosageOptions">
      <label class="radio">
        <input
          [attr.data-qa-id]="'STD Prevention Dosage Upgrade ' + option.label"
          formControlName="upgradeDosage"
          [value]="option.value"
          type="radio"
        />
        {{ option.label }} <span>(+${{ option.price }})</span>
      </label>
    </div>

    <!-- Opt-out option -->
    <div class="control">
      <label class="radio">
        <input
          [attr.data-qa-id]="'STD Prevention Dosage Upgrade Keep Current'"
          formControlName="upgradeDosage"
          value="No"
          type="radio"
        />
        Keep current dosage ({{ currentDosageData.dosage }})
      </label>
    </div>
  </div>

  <div hint class="hint">The higher dosage provides additional protection for high-risk exposures.</div>
</app-upgrade-dosage-upsell>
